import './App.css';
import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from "./components/ScrollToTop";

import AnnouncementBar from './components/home/announcementBar';
import Navbar from './components/navbar/navbar';
import Footer from './components/footer/footer';
import Loader from './components/Loader';

// Lazy-load heavy pages
const Home = lazy(() => import('./pages/home'));
const Contact = lazy(() => import('./components/home/contactSection'));
const Service = lazy(() => import('./components/home/serviceSection'));
const Project = lazy(() => import('./components/home/project'));
const Team = lazy(() => import('./components/home/team'));


const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Cancellation = lazy(() => import('./pages/Cancellation'));
const Refund = lazy(() => import('./pages/Refund'));

function App() {

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();

    const disableKeys = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableKeys);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeys);
    };
  }, []);

  return (
    <Router>
      {/* Header always renders instantly */}
      <ScrollToTop />
      <AnnouncementBar />
      <div className="top-wrapper">
        <Navbar />
      </div>

      <main>
        {/* Lazy-loaded pages */}
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/serviceSection" element={<Service />} />
            <Route path="/project" element={<Project />} />
            // <Route path="/team" element={<Team />} />
            <Route path="/contactSection" element={<Contact />} />
  
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cancellation" element={<Cancellation />} />
            <Route path="/refund" element={<Refund />} />
          </Routes>
        </Suspense>
      </main>

      {/* Footer always renders instantly */}
      <Footer />
    </Router>
  );
}

export default App;
